import React, { useRef } from "react";
import SlideVideosRow from "../SlideVideos/SlideVideos";
import "./ListCategories.css";
import FiveRow from "../FIveRow/FiveRow";
import RecommendedRow from "../RecommendedRow/RecommendedRow";

const ListCategories = ({ categories, spatialElementId }) => {
  const categoryListRef = useRef(null); // Ref for the middlebox wrapper
  const categoryRowRefs = useRef([]); // Array of refs for each category row

  return (
    <div
      className="middlebox-wrapper"
      ref={categoryListRef}
      style={{ overflow: "hidden", position: "relative" }}
    >
      <div id={spatialElementId} className="categoryList">
        {categories.map((category, index) =>
          parseInt(category.slideview) === 1 ? (
            <div
              key={index}
              className="category-row slide-row"
              ref={(el) => (categoryRowRefs.current[index] = el)}
            >
              <h2 className="category-title fw-bold">
                {category.category_name}
              </h2>
              <SlideVideosRow
                key={`${category.category_id}-${index}`}
                data={category}
                cIndex={index}
                hidden={false}
              />
            </div>
          ) : (
            <div
              key={index}
              className={`category-row ${
                index % 2 ? "bg-dark grid-row" : "bg-grey grid-row"
              } `}
              ref={(el) => (categoryRowRefs.current[index] = el)}
            >
              <h2 className="category-title fw-bold">
                {category.category_name}
              </h2>
              {category.category_name !== "Recommended" ? (
                <FiveRow category={category} />
              ) : (
                <RecommendedRow category={category} />
              )}
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ListCategories;
